import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/')({
  // /admin 접속 시 고객사 관리로 리다이렉트 (렌더링 전에 처리)
  beforeLoad: () => {
    throw redirect({ to: '/admin/customers' })
  },
})
